import { createContext } from "react";
const OrderLogContext = createContext();
export default OrderLogContext;
